
import { useEffect, useState, useCallback, useContext } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { showTost } from '../../showTost';
import { useTranslation } from 'react-i18next';

const Razorpay = ({ Amount, attributes, setShowPaymentBox }) => {
    const { t } = useTranslation();

    const { setPaymentRes, setTransactionId, setPaymentLod ,BaseUrl} = useContext(MyContext);

    const [userData, setUserData] = useState();

    const openPayModal = useCallback(async () => {
        setPaymentLod(false);

        try {
            const res = await axios.post(`${BaseUrl}user_api/create_order.php`,
                { amount: Amount }
            );

            if (res.data?.status) {

                const options = {
                    key: attributes,
                    amount: res?.data?.amount,
                    currency: "INR",
                    name: "Nabhiverse",
                    order_id: res?.data?.order_id,
                    description: "some description",
                    image: "android-icon-192x192.png",
                    handler: (response) => {
                        setPaymentRes("PaymentDone");
                        setTransactionId(response.razorpay_payment_id);
                    },
                    modal: {
                        ondismiss: () => {
                            setPaymentRes("PaymentFaild");
                        }
                    },
                    prefill: {
                        name: userData && userData?.name,
                        contact: userData && userData?.mobile,
                        email: userData && userData?.email,
                    },
                    notes: {
                        address: "some address",
                    },
                    theme: {
                        color: "#F37254",
                        hide_topbar: false,
                    },
                };

                const rzp1 = new window.Razorpay(options);
                rzp1.open();
            }
        } catch {
            showTost(t("PaymentFaild"), "error");
            setShowPaymentBox(false);
            setPaymentLod(false);
        }

    }, [Amount, attributes, setPaymentLod, setPaymentRes, setTransactionId, t, userData]);

    useEffect(() => {
        const localData = localStorage.getItem("LoginData");

        if (!Amount || !localData) return;

        const parsedData = JSON.parse(localData);
        setUserData(parsedData)
    }, [Amount]);

    useEffect(() => {
        if (userData && Amount) {
            openPayModal();
            sessionStorage.setItem("Amount", Amount);
        }
    }, [Amount, openPayModal, userData]);

    return null;
};

export default Razorpay;
